/*
 * WUWebApp
 * Author : Nikolaos Menis(nikos.menis@veriah.com)
 * Copyright 2020 Nikolaos Menis
 */
  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
//import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
//import Cookies                                             from 'js-cookie';
  //recaptcha_V2
  import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //recaptcha_V3
//import useRecaptchaV3                                      from "components/useRecaptchaV3/useRecaptchaV3.jsx";
  import { GoogleReCaptchaProvider, GoogleReCaptcha }        from 'react-google-recaptcha-v3';
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_ForgotPassService }                            from "../../_services";
  import { wu_AppVersion }                                   from "../../_services";
  //------
  // Style
  //------
  import ForgotPass1Style                                    from "./ForgotPass1Style.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
  import KeyboardBackspaceIcon                               from '@material-ui/icons/KeyboardBackspace'; //[goBack]
  //----------
  // variables
  //----------
  const filename = "ForgotPass1 ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  //[Lockers]
  var ForgotPass1_continue_locked = true;

class ForgotPass1 extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+props);}

    super(props);
    this.state = {
      dialog_msg                                             : "",
      dialog_isOpen                                          : false,

      viewPleaseWait_hidden                                  : true,

      email                                                  : "",
      email_hasError                                         : false,
      alert                                                  : null,

      //popup gotoStep2
      dialog_gotoStep2_msg                                   : "",
      dialog_gotoStep2_isOpen                                : false,

      //[HONEYMOON]
      textField0                                             : "", //4279034659
      textField0_hasError                                    : false,

      //[RECAPTCHA]
      recaptchaVersionSupported                            : "V3", //"V2", "V3", "NONE"
      //recaptcha_V3
      refreshReCaptchaV3                                   : false,
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    //[goBack]
    this.goBack                                                       = this.goBack.bind(this);

    this.handleSubmit                                                 = this.handleSubmit.bind(this);
    this.handleSubmit_isDisabled                                      = this.handleSubmit_isDisabled.bind(this);
    //recaptcha_V2
    this.handleSubmit_with_recaptcha                                  = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                                 = React.createRef();
    //recaptcha_V3
    this.handleSubmit_get_recaptchaV3_token                           = this.handleSubmit_get_recaptchaV3_token.bind(this);
    this.reset_recaptchaV3_token                                      = this.reset_recaptchaV3_token.bind(this);

    //popup gotoStep2
    this.dialog_gotoStep2_handleOpen                                  = this.dialog_gotoStep2_handleOpen.bind(this);
    this.dialog_gotoStep2_btn_add                                     = this.dialog_gotoStep2_btn_add.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view")); if(api.print_logs){console.log(methName+localStorage.getItem("prev_view"));}
    localStorage.setItem("curr_view", filename);                          if(api.print_logs){console.log(methName+localStorage.getItem("curr_view"));}

    if(localStorage.getItem("lang")!=='el' && localStorage.getItem("lang")!=='en'){ localStorage.setItem("lang","el"); }

    //Do nothing if---get
    if(localStorage.getItem("prev_view").trim()==="ForgotPass2"){
      try{ this.setState(JSON.parse(localStorage.getItem(filename.trim()))); }catch(err){;}
      this.stopSpinners();this.stopLockers();
      return;
    }
    //-------------
    //Do some reset
    //-------------
    try { localStorage.setItem("parserObject_omtregistrationTriggerOTP_req", ""); } catch(err){;}
    try { localStorage.setItem("parserObject_transhistorydetail_unique",""); } catch(err){;}
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}
    try { localStorage.setItem("CustomerWantedToLoginToBills", "false"); } catch(err){;}

    //[Lockers]
    this.stopLockers();
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}

    //-----------
    //recaptchaV3
    //-----------
    var recaptchaTokenV3 = localStorage.getItem("recaptchaTokenV3");
    //console.log(methName+"recaptchaTokenV3="+recaptchaTokenV3);
    if(recaptchaTokenV3===null || recaptchaTokenV3===""){
      setTimeout(function() { this.reset_recaptchaV3_token("init"); }.bind(this), 500);
    }
    this.reset_recaptchaV3_token_TIMER();
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    let methName = filename+"componentWillUnmount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    let methName = filename+"render ";
    if(api.print_logs){console.log(methName);}

    const classes = this.props.classes;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            {api.backButtonAtHeader === true ? (
              <GridContainer justify="center">
                <GridItem xs={2} sm={2} md={1}>
                  <div style={{ marginTop:20,marginBottom:10, textAlign:"left" }}>
                    {/* ----------[goBack Header]------------ */}
                    <Button style={{ backgroundColor:"#FFDD00" }} onClick={this.goBack}><KeyboardBackspaceIcon/></Button>
                  </div>
                </GridItem>
                <GridItem xs={10} sm={10} md={11}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("ForgotPass_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            ) : (
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={12}>
                  <div style={{ marginTop: 25 }}>
                    <div className={classes.labelHeader}>{this.NSInforString("ForgotPass_title")}</div>
                    <div className={classes.logo}><img src={logo} alt="logo" /></div>
                  </div>
                </GridItem>
              </GridContainer>
            )}

            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.ForgotPass_lbl_info1}>{this.NSInforString("ForgotPass_lbl_info1")}</div>
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.ForgotPass_lbl_info2}>{this.NSInforString("ForgotPass_lbl_info2")}</div>
              </GridItem>

              {/* ------------------------- */}
              {/* ----------[HONEYMOON]---- */}
              {/* ------------------------- */}
              <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                  <TextField
                    fullWidth
                    autoComplete={this.autoCompleteText_Textfields()}
                    error={this.state.textField0_hasError}
                    className={classes.textField0}
                    id={this.autoCompleteText_Textfields()}
                    label={this.autoCompleteText_Textfields()}
                    value={this.state.textField0}
                    InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                  />
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                <TextField
                  fullWidth
                  error={this.state.email_hasError}
                  className={classes.textField1}
                  id="email"
                  label={this.NSInforString("ForgotPass_plh1")}
                  defaultValue=""
                  value={this.state.email}
                  InputProps={{
                    fullWidth: true,
                    onChange: event => this.change(event, "email"),
                    type: "email"
                  }}
                />
              </GridItem>

              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.ForgotPass_lbl_info3}>{this.NSInforString("ForgotPass_lbl_info3")}</div>
              </GridItem>

              {/* ------------------------- */}
              {/* ----------[SPINNERS]----- */}
              {/* ------------------------- */}
              {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
                <GridContainer justify="center">
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                    <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                  </GridItem>
                  <GridItem xs={3} sm={3} md={3}></GridItem>
                </GridContainer>
              )}
              {/* ------------------------- */}
              {/* ----------[BUTTONS]------ */}
              {/* ------------------------- */}
              <GridItem xs={10} sm={10} md={10}>
                {/* -----------recaptcha_NONE -------------- */}
                {this.state.recaptchaVersionSupported === "NONE" ? (
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={this.handleSubmit_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.handleSubmit}
                      type="submit">
                      {this.NSInforString("ForgotPass_btn_next")}
                    </CustomButton>
                  </div>
                ) : ( "" )}
                {/* -----------recaptcha_V2 -------------- */}
                {this.state.recaptchaVersionSupported === "V2" ? (
                  <div className={classes.textCenter}>
                    <ReCAPTCHA
                      ref={ ref => this.recaptchaRef = ref }
                      locale={localStorage.getItem("lang")}
                      sitekey={api.captchKey}
                      onResolved={this.handleSubmit} />
                    <CustomButton
                      disabled={this.handleSubmit_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.handleSubmit_with_recaptcha}
                      type="submit">
                      {this.NSInforString("ForgotPass_btn_next")}
                    </CustomButton>
                  </div>
                ) : ( "" )}
                {/* -----------recaptcha_V3 -------------- */}
                {this.state.recaptchaVersionSupported === "V3" ? (
                  <div className={classes.textCenter}>
                    <GoogleReCaptchaProvider reCaptchaKey={api.captchKeyV3}>
                      <GoogleReCaptcha
                          className="google-recaptcha-custom-class"
                          onVerify={this.handleSubmit_get_recaptchaV3_token}
                          refreshReCaptcha={this.state.refreshReCaptchaV3}
                      />
                    </GoogleReCaptchaProvider>
                    <CustomButton
                      disabled={this.handleSubmit_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.handleSubmit}
                      type="submit">
                      {this.NSInforString("ForgotPass_btn_next")}
                    </CustomButton>
                  </div>
                ) : ( "" )}
              </GridItem>
              {/* -------------------------------------------------- */}
              {/* ----------[goBack Bottom]------------------------- */}
              {/* -------------------------------------------------- */}
              {api.backButtonAtBottom === true ? (
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    <CustomButton
                      disabled={false}
                      className={classes.backButton}
                      color="rose"
                      onClick={this.goBack}>
                      {this.NSInforString("ForgotPass_btn_prev")}
                    </CustomButton>
                  </div>
                </GridItem>
              ) : ( "" ) }

            </GridContainer>
          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* ---------------------------------------- */}
        {/* ----------[POPUP gotoStep2]------------- */}
        {/* ---------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_gotoStep2_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_gotoStep2_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <GridItem xs={12} sm={12} md={12}><div className={classes.viewRN_key}>{this.state.dialog_gotoStep2_msg}</div></GridItem>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton_gotoStep2} color="default" onClick={this.dialog_gotoStep2_btn_add}>{this.NSInforString("alert_OK")}</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------recaptcha_V3--------------------------------------
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  reset_recaptchaV3_token_TIMER = function() {
      var self = this;
      this.timer = setInterval(function() {
          self.reset_recaptchaV3_token("init");
      }, 90000)
  }
  //----------------------------------------------------------------------------------------------------
  reset_recaptchaV3_token(status) {
    let methName = filename+"reset_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if(this.state.recaptchaVersionSupported==="V3"){
      if(status==="init")   { this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3(status); return; }
      if(status==="success"){ localStorage.setItem("recaptchaTokenV3", ""); /*this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3();*/ return; }
      if(status==="failure"){ this.setState({"refreshReCaptchaV3" : !this.state.refreshReCaptchaV3 }); this.generateRecaptchaV3(status); return; }
      if(api.print_logs){console.log(methName+"this.state.refreshReCaptchaV3="+this.state.refreshReCaptchaV3);}
    }
  }
  //----------------------------------------------------------------------------------------------------
  generateRecaptchaV3(status) {
    let methName = filename+"generateRecaptchaV3 ";
    //if(api.print_logs){console.log(methName);}

    window.grecaptcha.execute(api.captchKeyV3, {action: "YOUR_ACTION_NAME"}).then(function(token) {
      if (token) {
        if(api.print_logs){console.log(methName+"status="+status+" token= "+token);}
        localStorage.setItem("recaptchaTokenV3", token);
      }
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  handleSubmit_isDisabled(){
    if(this.isLockersActive()===true){ return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.email.trim() === "") { this.setState({"email_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    if(this.verifyGenericItem("email",this.state.email)===false){
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.handleSubmit_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  //recaptcha_V3
  handleSubmit_get_recaptchaV3_token(token) {
    let methName = filename+"handleSubmit_get_recaptchaV3_token ";
    //if(api.print_logs){console.log(methName);}

    if (token && token.length>300) {
      if(api.print_logs){console.log(methName+new Date()+" token=" +token);}
      localStorage.setItem("recaptchaTokenV3", token);
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit(event) {
    let methName = filename+"handleSubmit ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    let shouldResetCaptcha = (this.state.recaptchaVersionSupported==="V2") ? true : false; //true;//api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.email.trim() === "") { this.setState({"email_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){this.stopLockers();if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    if(this.verifyGenericItem("email",this.state.email)===false){
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers(); return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("validation");
      this.stopLockers(); return;
    }
    //+++++++++++
    //[RECAPTCHA]
    //+++++++++++
    var recaptchaVerify = "";
    //recaptcha_V2
    if(this.state.recaptchaVersionSupported==="V2"){
      recaptchaVerify = shouldResetCaptcha ? JSON.stringify(this.recaptchaRef.getResponse()) : "";
      if(api.print_logs){console.log(methName+new Date()+" recaptchaVerify token= "+recaptchaVerify);}
    }
    //recaptcha_V3
    if(this.state.recaptchaVersionSupported==="V3"){
      recaptchaVerify = localStorage.getItem("recaptchaTokenV3");
      if(api.print_logs){console.log(methName+new Date()+"recaptchaVerify token= "+recaptchaVerify);}
    }
    //++++++++
    //Continue
    //++++++++
    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    let parserObject_omtreqchangepwd_req = {};
    parserObject_omtreqchangepwd_req["email"]           = this.state.email;
    parserObject_omtreqchangepwd_req["country"]         = "GR";
    parserObject_omtreqchangepwd_req["recaptchaVerify"] = recaptchaVerify;

    //event.preventDefault();
    this.startSpinners();
    setTimeout(function() { //Start the timer
      //---------------
      //checkAppVersion
      //---------------
      wu_AppVersion
      .wu_checkAppVersion(parserObject_checkAppVersion_req)
      .then(res => {
        if(localStorage.getItem("curr_view").trim()!=="ForgotPass1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
        //if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("success");
        //this.stopSpinners();
        parserObject_omtreqchangepwd_req["val1"] = res.val1;

        //------------------
        //wu_omtreqchangepwd
        //------------------
        wu_ForgotPassService
        .wu_omtreqchangepwd(parserObject_omtreqchangepwd_req)
        .then(res => {
          if(localStorage.getItem("curr_view").trim()!=="ForgotPass1"){if(api.print_logs){console.log(methName+"5A11");}return;}//5A11
          if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("success");
          this.stopLockers();this.stopSpinners();
          if(res.returnCode===0){
            this.dialog_gotoStep2_handleOpen(res.returnText,"NET");
          }
        })
        .catch(err => { //wu_omtregistrationTriggerOTP
          if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("failure");
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
        });
      })
      .catch(err => { //wu_checkAppVersion
        if(shouldResetCaptcha){this.recaptchaRef.reset();}this.reset_recaptchaV3_token("failure");
        this.stopLockers();this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="email"){
      this.setState({
        "email"          : eventTMP.trim(),
        "email_hasError" : (eventTMP.trim() === "") ? true : false,
      });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email"){ return wu_Utilities.wu_verifyEmail(val); }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  saveState(){
    localStorage.setItem(filename.trim(), JSON.stringify(this.state));//Do nothing if---set
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[goBack]------------------------------------------
  //----------------------------------------------------------------------------------------------------
  goBack(event) {
    //history.go(-1);
    history.goBack();
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({
      "dialog_isOpen" : true,
      "dialog_msg"    : dialog_msg
    });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups gotoStep2----------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_gotoStep2_handleOpen(dialog_msg,dType){
    setTimeout(function() {
      this.setState({
        "dialog_gotoStep2_isOpen" : true,
        "dialog_gotoStep2_msg"    : dialog_msg
      });
    }.bind(this), api.initialLoadGracePeriodMS);
    return;
  }
  //----------------------------------------------------------------------------------------------------
  dialog_gotoStep2_btn_add(){
    let methName = filename+"dialog_gotoStep2_btn_add ";
    if(api.print_logs){console.log(methName);}

    history.push(wu_Utilities.getNavigationURLs("ForgotPass2"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( ForgotPass1_continue_locked===true ){ return true;  }
    else                                    { return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    ForgotPass1_continue_locked = true;
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    ForgotPass1_continue_locked = false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"FP1"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
}
ForgotPass1.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { alert }    = state;
  const { dispatch } = state;
  return {
    dispatch,
    alert
  };
}
export default connect(mapStateToProps)(
  withStyles(ForgotPass1Style)(ForgotPass1)
);
